(function (ng) {
    var funcs = [],
        int = window.setInterval(function () {
            funcs.forEach(function (f) { f(); });
        }, 100);

    // Ensure the height of every child element matches the maximum
    ng.module('evo.Compare.Directives').directive('matchHeight', [function () {
        return {
            restrict: 'A',
            link: function (scope, $el) {
                var $this = ng.element($el),
                    thisWidth = $el.width(),
                    thisHeight = $el.height();

                // Set the child heights
                function setHeights() {
                    var width = $this.width();
                    var height = $this.height();
                    if (width === thisWidth && height === thisHeight)
                        return;

                    thisWidth = width;
                    thisHeight = height;

                    var $children = $this.children();

                    $children.height('auto');
                    $children.height(Math.max(34, $this.height()));
                };

                funcs.push(setHeights);
            }
        };
    }]);
})(angular);